var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentalHealthNewIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_88029",
    "data-name": "Group 88029",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25592",
    "data-name": "Rectangle 25592",
    width: 63,
    height: 63,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88028",
    "data-name": "Group 88028",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308394",
    "data-name": "Path 308394",
    d: "M31.5,8.481a5.3,5.3,0,1,1-5.22,5.3,5.26,5.26,0,0,1,5.22-5.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308395",
    "data-name": "Path 308395",
    d: "M28.434,13.781a5.283,5.283,0,0,1,4.142-5.187A5.155,5.155,0,0,0,31.5,8.481a5.3,5.3,0,0,0,0,10.6,5.155,5.155,0,0,0,1.076-.113,5.283,5.283,0,0,1-4.142-5.187",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308396",
    "data-name": "Path 308396",
    d: "M24.231,26.351V28.4H38.769V26.351a7.269,7.269,0,0,0-14.538,0",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308397",
    "data-name": "Path 308397",
    d: "M32.577,19.161a7.349,7.349,0,0,0-1.077-.08,7.269,7.269,0,0,0-7.269,7.269V28.4h2.154V26.35a7.27,7.27,0,0,1,6.192-7.189",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308398",
    "data-name": "Path 308398",
    d: "M38.66,38.365H24.34a1.617,1.617,0,0,1-1.607-1.448l-1.008-9.69a1.613,1.613,0,0,1,1.6-1.782H39.669a1.614,1.614,0,0,1,1.606,1.782l-1.009,9.69a1.615,1.615,0,0,1-1.606,1.448",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308399",
    "data-name": "Path 308399",
    d: "M24.888,36.917l-1.009-9.689a1.615,1.615,0,0,1,1.606-1.783H23.331a1.615,1.615,0,0,0-1.606,1.783l1.009,9.689a1.615,1.615,0,0,0,1.607,1.448H26.5a1.615,1.615,0,0,1-1.607-1.448",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308400",
    "data-name": "Path 308400",
    d: "M31.5,29.617a2.288,2.288,0,1,1-2.288,2.288A2.288,2.288,0,0,1,31.5,29.617",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308401",
    "data-name": "Path 308401",
    d: "M31.5,35a3.1,3.1,0,1,1,3.1-3.1A3.1,3.1,0,0,1,31.5,35m0-4.577a1.481,1.481,0,1,0,1.481,1.481A1.483,1.483,0,0,0,31.5,30.424",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25588",
    "data-name": "Rectangle 25588",
    width: 4.742,
    height: 18.45,
    transform: "translate(29.129 43.742)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25589",
    "data-name": "Rectangle 25589",
    width: 1.885,
    height: 18.45,
    transform: "translate(29.129 43.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25590",
    "data-name": "Rectangle 25590",
    width: 37.423,
    height: 5.377,
    transform: "translate(12.788 38.365)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25591",
    "data-name": "Rectangle 25591",
    width: 37.423,
    height: 2.019,
    transform: "translate(12.788 38.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308402",
    "data-name": "Path 308402",
    d: "M19.736,47.608V59.231a2.8,2.8,0,1,1-5.59,0V48.536H8.282A2.692,2.692,0,0,1,5.59,45.844V43.57H15.7a4.038,4.038,0,0,1,4.038,4.038",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308403",
    "data-name": "Path 308403",
    d: "M15.7,43.569H5.59v2.019h9.973a2.154,2.154,0,0,1,2.153,2.154V61.25a2.823,2.823,0,0,1-.088.687,2.794,2.794,0,0,0,2.108-2.706V47.607A4.039,4.039,0,0,0,15.7,43.569",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308404",
    "data-name": "Path 308404",
    d: "M14.536,28.56l3.948,5.363h4.1a2.221,2.221,0,1,1,0,4.442H14.4v5.2H5.59V31.5a4.955,4.955,0,0,1,8.946-2.938",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308405",
    "data-name": "Path 308405",
    d: "M10.545,26.542A4.955,4.955,0,0,0,5.59,31.5V43.569H7.744V31.5a4.957,4.957,0,0,1,3.875-4.836,4.986,4.986,0,0,0-1.074-.119",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308406",
    "data-name": "Path 308406",
    d: "M10.436,16.042a5.06,5.06,0,0,1,4.846,5.25,5.061,5.061,0,0,1-4.846,5.25,5.061,5.061,0,0,1-4.846-5.25,5.06,5.06,0,0,1,4.846-5.25",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308407",
    "data-name": "Path 308407",
    d: "M7.744,21.292a5.176,5.176,0,0,1,3.769-5.118,4.506,4.506,0,0,0-1.077-.132,5.061,5.061,0,0,0-4.846,5.25,5.061,5.061,0,0,0,4.846,5.25,4.455,4.455,0,0,0,1.077-.132,5.176,5.176,0,0,1-3.769-5.118",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308408",
    "data-name": "Path 308408",
    d: "M43.264,47.608V59.231a2.8,2.8,0,1,0,5.59,0V48.536h5.864a2.692,2.692,0,0,0,2.692-2.692V43.57H47.3a4.038,4.038,0,0,0-4.038,4.038",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308409",
    "data-name": "Path 308409",
    d: "M47.3,43.569H57.41v2.019H47.438a2.154,2.154,0,0,0-2.154,2.154V61.25a2.873,2.873,0,0,0,.087.687,2.794,2.794,0,0,1-2.107-2.706V47.607A4.038,4.038,0,0,1,47.3,43.569",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308410",
    "data-name": "Path 308410",
    d: "M48.464,28.56l-3.948,5.363h-4.1a2.221,2.221,0,0,0,0,4.442H48.6v5.2H57.41V31.5a4.955,4.955,0,0,0-8.946-2.938",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308411",
    "data-name": "Path 308411",
    d: "M52.455,26.542A4.955,4.955,0,0,1,57.41,31.5V43.569H55.256V31.5a4.957,4.957,0,0,0-3.875-4.836A4.986,4.986,0,0,1,52.455,26.542Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308412",
    "data-name": "Path 308412",
    d: "M52.564,16.042a5.06,5.06,0,0,1,4.846,5.25,4.862,4.862,0,1,1-9.692,0,5.06,5.06,0,0,1,4.846-5.25",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308413",
    "data-name": "Path 308413",
    d: "M55.256,21.292a5.176,5.176,0,0,0-3.769-5.118,4.506,4.506,0,0,1,1.077-.132,5.061,5.061,0,0,1,4.846,5.25,5.061,5.061,0,0,1-4.846,5.25,4.455,4.455,0,0,1-1.077-.132,5.176,5.176,0,0,0,3.769-5.118",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308414",
    "data-name": "Path 308414",
    d: "M62.192,61.385h-.269V27.6a.808.808,0,1,0-1.615,0V47.721H57.669a3.476,3.476,0,0,0,.549-1.878V31.5a5.765,5.765,0,0,0-2.833-4.96,6.146,6.146,0,0,0,2.833-5.246,5.667,5.667,0,1,0-11.308,0,6.161,6.161,0,0,0,2.729,5.183,5.749,5.749,0,0,0-1.826,1.606l-3.7,5.034H41.474l.6-5.8c.175-1.677-1.3-2.563-2.688-2.675a8.106,8.106,0,0,0-4.676-5.693,6.029,6.029,0,1,0-6.431,0,8.106,8.106,0,0,0-4.675,5.694c-1.385.111-2.863,1-2.688,2.674l.6,5.8H18.892l-3.7-5.034a5.764,5.764,0,0,0-1.826-1.607,6.158,6.158,0,0,0,2.729-5.182,5.872,5.872,0,0,0-5.654-6.057,5.873,5.873,0,0,0-5.654,6.057,6.146,6.146,0,0,0,2.833,5.246A5.765,5.765,0,0,0,4.782,31.5V45.843a3.476,3.476,0,0,0,.549,1.878H2.692V27.6a.808.808,0,1,0-1.615,0V61.385H.808A.808.808,0,1,0,.808,63H62.192a.808.808,0,1,0,0-1.615m-1.884,0H48.945a3.585,3.585,0,0,0,.717-2.154V49.343l10.646-.006ZM19.454,44.55h8.867V61.385H19.827a3.585,3.585,0,0,0,.717-2.154V47.608A4.822,4.822,0,0,0,19.454,44.55ZM15.2,39.173H47.8v3.588H15.2ZM43.546,44.55a4.822,4.822,0,0,0-1.09,3.058V59.231a3.585,3.585,0,0,0,.717,2.154H34.679V44.55Zm5.308,3.171a.808.808,0,0,0-.808.808v10.7a1.987,1.987,0,0,1-3.974,0V47.608a3.236,3.236,0,0,1,2.189-3.058L56.6,44.377v1.466a1.885,1.885,0,0,1-1.749,1.878Zm-.329-26.429a4.057,4.057,0,1,1,8.077,0,4.057,4.057,0,1,1-8.077,0M44.516,34.731a.808.808,0,0,0,.651-.329l3.947-5.363A4.148,4.148,0,0,1,56.6,31.5V42.762H49.411V35.529a.808.808,0,0,0-1.616,0v2.029H40.42a1.413,1.413,0,1,1,0-2.827ZM27.087,13.781A4.414,4.414,0,1,1,31.5,18.274,4.459,4.459,0,0,1,27.087,13.781ZM31.5,19.889a6.471,6.471,0,0,1,6.228,4.748H25.272A6.471,6.471,0,0,1,31.5,19.889m-8.169,6.364H39.669a.807.807,0,0,1,.8.891l-.628,6.027a3.027,3.027,0,0,0-2.1,4.387H25.258a3.027,3.027,0,0,0-2.1-4.387l-.628-6.027A.808.808,0,0,1,23.331,26.253ZM6.4,21.292a4.259,4.259,0,0,1,4.038-4.442,4.26,4.26,0,0,1,4.039,4.442,4.26,4.26,0,0,1-4.039,4.443A4.26,4.26,0,0,1,6.4,21.292M6.4,31.5a4.148,4.148,0,0,1,7.488-2.459L17.833,34.4a.808.808,0,0,0,.651.329h4.1a1.413,1.413,0,1,1,0,2.827H15.2V35.529a.808.808,0,0,0-1.616,0v7.233H6.4Zm0,14.345V44.377l10.341.173a3.236,3.236,0,0,1,2.189,3.058V59.231a1.987,1.987,0,1,1-3.974,0v-10.7a.808.808,0,0,0-.808-.808h-6A1.885,1.885,0,0,1,6.4,45.843M2.692,49.337l10.646.006v9.888a3.585,3.585,0,0,0,.717,2.154H2.692ZM29.937,44.55h3.127V61.384H29.937Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308415",
    "data-name": "Path 308415",
    d: "M43.279.808H54.587A1.615,1.615,0,0,1,56.2,2.423V7.065a1.616,1.616,0,0,1-1.615,1.616h-3.62L47.1,13.193l-.022-4.512h-3.8a1.616,1.616,0,0,1-1.615-1.616V2.423A1.615,1.615,0,0,1,43.279.808",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308416",
    "data-name": "Path 308416",
    d: "M45.433.808H43.279a1.615,1.615,0,0,0-1.615,1.615V7.065a1.616,1.616,0,0,0,1.615,1.616h2.154a1.616,1.616,0,0,1-1.615-1.616V2.423A1.615,1.615,0,0,1,45.433.808",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308417",
    "data-name": "Path 308417",
    d: "M47.1,14a.817.817,0,0,1-.808-.8l-.017-3.708h-3a2.426,2.426,0,0,1-2.423-2.423V2.423A2.426,2.426,0,0,1,43.279,0H54.587A2.426,2.426,0,0,1,57.01,2.423V7.065a2.426,2.426,0,0,1-2.423,2.423H51.339l-3.621,4.229A.81.81,0,0,1,47.1,14ZM43.279,1.615a.809.809,0,0,0-.808.808V7.065a.809.809,0,0,0,.808.807h3.8a.808.808,0,0,1,.808.8l.011,2.343,2.453-2.864a.807.807,0,0,1,.613-.283h3.62a.808.808,0,0,0,.807-.807V2.423a.808.808,0,0,0-.807-.808Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308418",
    "data-name": "Path 308418",
    d: "M52.426,5.605h-7.02a.808.808,0,1,1,0-1.615h7.02a.808.808,0,1,1,0,1.615",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308419",
    "data-name": "Path 308419",
    d: "M19.721.819H8.413A1.615,1.615,0,0,0,6.8,2.434V7.076A1.616,1.616,0,0,0,8.413,8.692h3.62L15.9,13.2l.022-4.512h3.8a1.616,1.616,0,0,0,1.615-1.616V2.434A1.615,1.615,0,0,0,19.721.819",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308420",
    "data-name": "Path 308420",
    d: "M10.567.819H8.413A1.615,1.615,0,0,0,6.8,2.434V7.076A1.616,1.616,0,0,0,8.413,8.692h2.154A1.616,1.616,0,0,1,8.952,7.076V2.434A1.615,1.615,0,0,1,10.567.819",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308421",
    "data-name": "Path 308421",
    d: "M15.9,14.012a.808.808,0,0,1-.614-.283L11.661,9.5H8.413A2.426,2.426,0,0,1,5.99,7.077V2.435A2.426,2.426,0,0,1,8.413.012H19.721a2.426,2.426,0,0,1,2.423,2.423V7.077A2.426,2.426,0,0,1,19.721,9.5h-3L16.7,13.208a.815.815,0,0,1-.807.8M8.413,1.627a.809.809,0,0,0-.808.808V7.077a.809.809,0,0,0,.808.807h3.619a.811.811,0,0,1,.614.283L15.1,11.031l.012-2.343a.808.808,0,0,1,.807-.8h3.8a.807.807,0,0,0,.807-.807V2.435a.807.807,0,0,0-.807-.808Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308422",
    "data-name": "Path 308422",
    d: "M17.594,5.617h-7.02a.808.808,0,1,1,0-1.615h7.02a.808.808,0,1,1,0,1.615",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalHealthNewIcon2);
export default __webpack_public_path__ + "static/media/Mental_Health_New_Icon_2.197eff76d46cf8b3e8d2291417215051.svg";
export { ForwardRef as ReactComponent };